{
  "info": "Információ",
  "negative": "Hiba",
  "positive": "Siker"
}
